<ng-template #scoreBar>
  <div class="score-bar-middle">
    <button class="push-button play-btn" style="margin-bottom: 4px;"
            [disabled]="loading"
            [class.push-button-enabled]="!loading"
            [class.button-green]="!loading && playButtonActive"
            [class.button-blue]="!loading && !playButtonActive"
            (click)="playButtonActive? playMidi(0) : stopMidi()">
      <mat-icon class="question-icon">{{playButtonActive? "music_note" : "volume_off"}}</mat-icon></button>

    <div class="spacer"></div>

    <div class="stars-wrapper"
         [class.stars-wrapper-absolute]="!playerLayoutOpposite"
         [class.flex-row]="!playerLayoutOpposite"
         [class.flex-column]="playerLayoutOpposite">
      <div class="stars red">
        <mat-icon
          [class.rotate180]="playerLayoutOpposite"
          [class.flip-horizontal]="!playerLayoutOpposite"
          *ngFor="let _ of [].constructor(calculateEmptyStars(player2stars))">star_border</mat-icon>
        <mat-icon
          [class.rotate180]="playerLayoutOpposite"
          [class.flip-horizontal]="!playerLayoutOpposite"
          *ngIf="player2stars % 1 == 0.5" class="half-star">star_half</mat-icon>
        <mat-icon
          [class.rotate180]="playerLayoutOpposite"
          [class.flip-horizontal]="!playerLayoutOpposite"
          *ngFor="let _ of [].constructor(Math.floor(player2stars))">star</mat-icon>
      </div>

      <div class="stars blue">
        <mat-icon *ngFor="let _ of [].constructor(calculateEmptyStars(player1stars))">star_border</mat-icon>
        <mat-icon *ngIf="player1stars % 1 == 0.5" class="half-star">star_half</mat-icon>
        <mat-icon *ngFor="let _ of [].constructor(Math.floor(player1stars))">star</mat-icon>
      </div>
    </div>

    <button class="push-button play-btn button-white push-button-enabled" style="margin-bottom: 4px;"
            (click)="toggleLayout()">
      <mat-icon
        class="question-icon"
        [class.rotate90]="playerLayoutOpposite">
        screen_rotation</mat-icon>
    </button>

    <button class="push-button play-btn button-red push-button-enabled" style="margin-bottom: 4px;"
            (click)="onExit()">
      <mat-icon class="question-icon">logout</mat-icon>
    </button>
  </div>
</ng-template>

<div class="twoPlayerContainer flex-column">

  <ng-container *ngIf="!playerLayoutOpposite" [ngTemplateOutlet]="scoreBar"></ng-container>

  <div class="twoPlayerContainer"
       [class.flex-row]="!playerLayoutOpposite"
       [class.flex-column]="playerLayoutOpposite"
  >
    <app-game #player2 class="player2"
              [class.player-opposite]="playerLayoutOpposite"
              [class.rotated]="playerLayoutOpposite"
              [class.player-side-by-side]="!playerLayoutOpposite"
              [player]="2"
              [message]="player2Message"
              (begin)="begin()"
              (exit)="onExit()"
              (exitImmediate)="onExit()"
              (restart)="onRestart()"
              (optionSelected)="onPlayerOptionSelected(2, $event)"
              (info)="openInfoDialog()"
    ></app-game>

    <ng-container *ngIf="playerLayoutOpposite" [ngTemplateOutlet]="scoreBar"></ng-container>

    <app-game #player1 class="player1"
              [class.player-opposite]="playerLayoutOpposite"
              [class.player-side-by-side]="!playerLayoutOpposite"
              [player]="1"
              [message]="player1Message"
              (begin)="begin()"
              (exit)="onExit()"
              (exitImmediate)="onExit()"
              (restart)="onRestart()"
              (optionSelected)="onPlayerOptionSelected(1, $event)"
              (info)="openInfoDialog()"
    ></app-game>


  </div>

</div>
